import noop from 'lodash/noop';
import React from 'react';
import Modal, { ModalProps } from '.';

export type ModalWrapperProps = ModalProps & {
  headerTitle?: string;
  headerDescription?: string;
  onClose?: () => void;
  showHeader?: boolean;
};

const ModalWrapper = ({
  headerTitle = '',
  headerDescription = '',
  onClose: handleCloseModal = noop,
  children,
  showHeader = true,
  ...restProps
}: ModalWrapperProps) => (
  <Modal
    overlayClassName="justify-center items-end md:items-center"
    className={{
      base:
        'rounded-t-lg md:rounded-br-lg transition-transform translate-y-9/10 md:translate-y-none md:scale-40',
      afterOpen: 'translate-y-none md:scale-100',
      beforeClose: 'translate-y-full md:translate-y-none'
    }}
    contentStyle={{
      width: '100%',
      maxWidth: '450px'
    }}
    {...restProps}
  >
    {showHeader && (
      <Modal.Header
        title={headerTitle}
        description={headerDescription}
        onClose={handleCloseModal}
      />
    )}
    {children}
  </Modal>
);

export default ModalWrapper;
